import { Component, OnInit } from '@angular/core';
import { SessionService } from './store/session/session.service';
import { filter } from 'rxjs/operators';
import { FloOverlayService } from './services/flo-overlay.service';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent implements OnInit {
	constructor(
		private sessionService: SessionService,
		private floOverlay: FloOverlayService
	) {}

	ngOnInit(): void {
		this.floOverlay.init();
		this.sessionService
			.isAuthenticated()
			.pipe(filter(isAuthenticated => isAuthenticated))
			.subscribe(() => {
				this.sessionService.getUser().subscribe();
			});
	}
}
